import {
  Component,
  DestroyRef,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { CustomerModerationViewModel } from '../../shared/models/customer-moderation.model';
import {
  BrandingModerationAttributeEnum,
  CustomerModerationAttributeEnum,
} from '../../shared/models/customer-changes-enum';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '@admin/core/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-customer-moderation-edit',
  templateUrl: './customer-moderation-edit.component.html',
  styleUrls: ['./customer-moderation-edit.component.less'],
  standalone: false,
})
export class CustomerModerationEditComponent {
  @Input() customer: CustomerModerationViewModel;
  @Input() customerId: number;
  @Output() approveCustomer: EventEmitter<string> = new EventEmitter<string>();
  @Output() rejectCustomer: EventEmitter<string> = new EventEmitter<string>();
  @Output() updateData: EventEmitter<number> = new EventEmitter<number>();

  @ViewChild('originalDescription') originalDescription: ElementRef;
  @ViewChild('editedDescription') editedDescription: ElementRef;

  ngAfterViewChecked() {
    if (this.originalDescription && this.editedDescription) {
      this.setEqualHeight();
    }
  }

  setEqualHeight() {
    const firstHeight = this.originalDescription.nativeElement.offsetHeight;
    const secondHeight = this.editedDescription.nativeElement.offsetHeight;

    const maxHeight = Math.max(firstHeight, secondHeight);

    this.renderer.setStyle(
      this.originalDescription.nativeElement,
      'height',
      `${maxHeight}px`
    );
    this.renderer.setStyle(
      this.editedDescription.nativeElement,
      'height',
      `${maxHeight}px`
    );
  }

  getCustomerData() {
    this.updateData.emit(this.customerId);
  }

  getEmployeesLabel(from: number, to: number) {
    if (from && to) {
      return `${from} - ${to}`;
    } else if (from && !to) {
      return `${from} ${this.translateService.instant('label.From')}`;
    } else if (!from && to) {
      return `${to} ${this.translateService.instant('label.To')}`;
    } else {
      return '';
    }
  }

  public customerEntityAttributes: any;
  public brandingEntityAttributes: any;

  constructor(
    private renderer: Renderer2,
    private destroyRef: DestroyRef,
    private translateService: TranslateService,
    private authService: AuthService,
  ) {
    this.customerEntityAttributes = CustomerModerationAttributeEnum;
    this.brandingEntityAttributes = BrandingModerationAttributeEnum;
  }

  onApprove(customerModerationId) {
    this.approveCustomer.emit(customerModerationId);
  }

  onReject(customerModerationId) {
    this.rejectCustomer.emit(customerModerationId);
  }

  onLoginAsCustomer(customerId: number){
    this.authService.loginAsCustomer(customerId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      //display message
    });
  }
}
